import { render, staticRenderFns } from "./ManagePendingBookings.vue?vue&type=template&id=715fef57&scoped=true"
import script from "./ManagePendingBookings.vue?vue&type=script&lang=js"
export * from "./ManagePendingBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715fef57",
  null
  
)

export default component.exports